import { useQuery } from '@tanstack/react-query';

import { getSummaryName } from '@/components/memul/detail/sub/summaryInfo/summaryName';
import { BUSINESS_DIV_TYPE, BusinessDivKey } from '@/const/buildingType';
import { MemulDetailItemType } from '@/service/memul/memulDetailType';
import queries from '@/service/memul/memulQueries';
import useMobileStore from '@/store/mobileStore';
import { numberToNormalPrice } from '@/utils/js/number';
import { sendTextMessage } from '@/utils/js/sms';

interface OftenMemulProps {
  data: MemulDetailItemType;
  close: () => void;
}

export default function OftenMemulBottomSheet({ data, close }: OftenMemulProps) {
  const { data: relatorData } = useQuery({
    ...queries.realtorInfo(data.articleCd),
    select: (data) => data.data,
    enabled: !!data.articleCd,
  });
  const { data: memulData } = useQuery({
    ...queries.memulDetail(data.articleCd),
    select: (data) => data.data,
  });
  const { currentDevice } = useMobileStore();

  const handlePriceText = ({ businessDiv, tradePrice, depositPrice }: any) => {
    if (businessDiv === 'M' || businessDiv === 'T') {
      return `${numberToNormalPrice({ value: depositPrice })} / ${numberToNormalPrice({ value: tradePrice })}`;
    } else {
      return `${numberToNormalPrice({ value: tradePrice })}`;
    }
  };

  const handleSmsText = () => {
    return `[이실장] ${getSummaryName(memulData, 'villaDanji')} ${BUSINESS_DIV_TYPE[data.businessDiv as BusinessDivKey]} ${handlePriceText(data)} 매물 문의드립니다.\n${window.location.href}`;
  };

  return (
    <>
      <div className="wrap_often_memul">
        <div className="inner pad">
          <div className="third_visit">
            <i className="icon_check"></i>
            <p className="desc">
              <strong>동일한 매물을 3번 이상 보았어요!</strong>
              고민하지 말고 문의해보세요!
            </p>
          </div>
          <div className="property_info">
            <div className="tag_div">
              <span className="tag">매물번호 {data.articleCd}</span>
            </div>
            <div className="price_info">
              <p
                className={`type  
                ${data.businessDiv === 'S' ? 'text_blue' : ''}  
                ${data.businessDiv === 'Y' ? 'text_green' : ''}     
                ${data.businessDiv === 'M' ? 'text_pink' : ''}     
                ${data.businessDiv === 'T' ? 'text_mint' : ''}`}
              >
                {BUSINESS_DIV_TYPE[data.businessDiv as BusinessDivKey]}
              </p>
              <p className="price">{handlePriceText(data)}</p>
            </div>
            <address className="address">{getSummaryName(data, 'villaDanji')}</address>
          </div>
        </div>
      </div>

      {relatorData && (
        <div className="bottom_btn">
          <div className="group_btn ratio">
            {relatorData.phoneExps === 'A' || relatorData.phoneExps === 'C' ? (
              <>
                <a href={`tel:` + relatorData.cphone} className="btn_gray50">
                  <i className="icon_call_black"></i>
                  전화
                </a>
                <a
                  href={sendTextMessage(relatorData.cphone, handleSmsText(), currentDevice!)}
                  className="btn_primary"
                >
                  <i className="icon_text_msg"></i>
                  문자
                </a>
              </>
            ) : (
              <a href={`tel:` + relatorData.rphone} className="btn_primary">
                <i className="icon_call_white"></i>
                전화
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
}
